import { motion } from "framer-motion";
import { Phone, ArrowRight, BadgeCheck } from "lucide-react";
import { COMPANY, IMAGES } from "../../data/content";

const scrollToContact = () =>
  document.querySelector("#kontakt")?.scrollIntoView({ behavior: "smooth" });

export const Hero = () => (
  <section data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden bg-[#1F2933]">
    <div className="absolute inset-0 overflow-hidden">
      <img
        src={IMAGES.hero}
        alt="Hochwertig gefliestes modernes Badezimmer"
        className="w-full h-full object-cover animate-kenburns"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#1F2933]/90 via-[#1F2933]/70 to-[#1F2933]/40" />
    </div>

    <div className="relative max-w-7xl mx-auto px-6 lg:px-8 w-full pt-32 pb-20">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-3xl"
      >
        <div className="inline-flex items-center gap-2 border border-[#C9B79C]/50 text-[#C9B79C] px-4 py-2 text-xs uppercase tracking-[0.2em] mb-8">
          <BadgeCheck size={15} />
          Meisterbetrieb · Handwerkskammer Hamburg
        </div>

        <h1 className="font-heading font-bold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.08]">
          Ihr Fliesenleger-Meisterbetrieb in Hamburg —{" "}
          <span className="text-[#C9B79C]">seit über 40 Jahren</span>
        </h1>

        <p className="mt-6 text-base md:text-lg text-white/85 leading-relaxed max-w-2xl">
          Fliesen, Naturstein, Bad- und Balkonsanierung: sauber, präzise und
          termintreu. Persönlich begleitet von {COMPANY.owner},{" "}
          {COMPANY.ownerTitle} — alles aus einer Hand.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-4">
          <button data-testid="hero-cta-offer" onClick={scrollToContact} className="btn-primary">
            Kostenloses Angebot anfordern <ArrowRight size={16} />
          </button>
          <a data-testid="hero-cta-call" href={COMPANY.phoneLink} className="btn-light">
            <Phone size={16} /> Jetzt anrufen
          </a>
        </div>

        <p className="mt-8 text-sm text-white/60">
          {COMPANY.street}, {COMPANY.city} · Tätig in ganz Hamburg und Umgebung
        </p>
      </motion.div>
    </div>
  </section>
);
